//© 2025 Kaitlyn Troxell
import React, { useState } from "react";
import LoadingSpinner from './LoadingSpinner';

function ContractorDetailsModal({ 
  selectedContractor, 
  setSelectedContractor, 
  updateContractorById, 
  deleteContractorById 
}) {
  const [formData, setFormData] = useState({ ...selectedContractor });
  const [loading, setLoading] = useState(false);

  if (!selectedContractor) return null;

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSave = async () => {
    setLoading(true);
    try {
      await updateContractorById(formData.id, formData);
      setSelectedContractor(null);
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async () => {
    await deleteContractorById(formData.id);
    setSelectedContractor(null);
  };

  return (
    <>
      {loading && <LoadingSpinner message="Saving changes..." />}
      <div className="modal-backdrop">
        <div className="modal-container contractor-modal">
          <h3 className="modal-title">Contractor Details</h3>

          <div className="contractor-detail">
            <label>Name:</label>
            <input 
              type="text" 
              name="name" 
              value={formData.name || ""} 
              onChange={handleChange} 
            />
          </div>

          <div className="contractor-detail">
            <label>Trade:</label>
            <input 
              type="text" 
              name="trade" 
              value={formData.trade || ""} 
              onChange={handleChange} 
            />
          </div>

          <div className="contractor-detail">
            <label>Phone:</label>
            <input 
              type="text" 
              name="phone" 
              value={formData.phone || ""} 
              onChange={handleChange} 
            />
          </div>

          <div className="contractor-detail">
            <label>Email:</label>
            <input 
              type="email" 
              name="email" 
              value={formData.email || ""} 
              onChange={handleChange} 
            />
          </div>

          <div className="contractor-detail">
            <label>Rating (1–5):</label>
            <input 
              type="number" 
              name="rating" 
              min="1" 
              max="5" 
              value={formData.rating || ""} 
              onChange={handleChange} 
            />
          </div>

          <div className="modal-actions contractor-actions">
            <button 
              onClick={handleDelete} 
              className="delete-btn"
            >
              Delete Contractor
            </button>

            <div className="action-group">
              <button 
                onClick={handleSave} 
                className="save-btn"
              >
                Save Changes
              </button>

              <button 
                onClick={() => setSelectedContractor(null)} 
                className="modal-cancel-btn"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default ContractorDetailsModal;
